var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessTick = function SvgSuccessTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M10 3.035a7.892 7.892 0 1 0 0 15.784 7.892 7.892 0 0 0 0-15.784m3.467 6.25L9.092 13.66a.75.75 0 0 1-.517.217.71.71 0 0 1-.517-.217l-1.891-1.892a.734.734 0 0 1 0-1.033.734.734 0 0 1 1.033 0l1.375 1.375 3.858-3.858a.734.734 0 0 1 1.034 0 .734.734 0 0 1 0 1.033"
  })));
};
export default SvgSuccessTick;